import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import {
  catchError,
  finalize,
  Observable,
  shareReplay,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { LanguageService } from 'sham-components/services';
import { LoginResponse } from './auth-api';
import { AuthService } from './auth.service';

let refreshRequest$: Observable<LoginResponse> | null = null;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = sessionStorage.getItem('accessToken');
  const guestToken = localStorage.getItem('X-Guest-Token');
  const authService = inject(AuthService);
  const langService = inject(LanguageService);
  const currentLang = langService.currentLang();

  let headers = req.headers.set('Accept-Language', currentLang);

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }
  if (guestToken) {
    headers = headers.set('X-Guest-Token', guestToken);
  }

  const cloned = req.clone({ headers });

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      const isAuthRequest =
        req.url.includes('/api/v1/auth/login') ||
        req.url.includes('/api/v1/auth/refresh-token');
      if (error.status === 401 && !isAuthRequest) {
        return handle401Error(cloned, next, authService);
      }
      return throwError(() => error);
    }),
    tap((event) => {
      if (event instanceof HttpResponse) {
        const newGuestToken = event.headers.get('X-Guest-Token');
        if (newGuestToken) {
          localStorage.setItem('X-Guest-Token', newGuestToken);
        }
      }
    }),
  );
};

function handle401Error(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  authService: AuthService,
): Observable<HttpEvent<unknown>> {
  if (!refreshRequest$) {
    refreshRequest$ = authService.refreshToken().pipe(
      finalize(() => (refreshRequest$ = null)),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
  }

  return refreshRequest$.pipe(
    switchMap((response) =>
      next(
        req.clone({
          setHeaders: { Authorization: `Bearer ${response.accessToken}` },
        }),
      ),
    ),
  );
}
